<div class="peekaboo-modal">
  <div class="modal-header">
    <h2>KC Topics & Inquiry/Events Links</h2>
    <div class="close-btn">
      <button mat-icon-button mat-dialog-close>
        <f-icon [iconConfig]="iconConfig"></f-icon>
      </button>
    </div>
  </div>
  <div class="modal-content">
    <div class="disclaimer">
      <p>
        <i class="fa-light fa-circle-exclamation"></i> Reminder: If self-service
        is an option, encourage the customer to use it.
      </p>
    </div>
    <section *ngIf="topicListByDomainError" class="error-wrapper">
      <f-alert variant="error">
        <p class="full-width">
          {{peekabooErrorMsg}}
        </p>
        <button *ngIf="showRefreshIcon" (click)="getDomainTopics()" mat-button color="primary" title="Refresh" class="btn-refresh">
          <i class="fa-solid fa-arrows-rotate"></i>
        </button>
      </f-alert>
    </section> 
    <section *ngIf="domainTopicsLinksSectionsError" class="error-wrapper">
      <f-alert variant="error">
        <p class="full-width">
          {{peekabooErrorMsg}}
        </p>
        <button (click)="getDomainTopicsLinksSections()" mat-button color="primary" title="Refresh" class="btn-refresh">
          <i class="fa-solid fa-arrows-rotate"></i>
        </button>
      </f-alert>
    </section> 

    <section *ngIf="showRefreshIconForLinksSectionsError" class="error-wrapper">
      <f-alert variant="error">
        <p class="full-width">
          {{peekabooErrorMsg}}
        </p>
        <button (click)="refreshSelectedTopicLinks()" mat-button color="primary" title="Refresh" class="btn-refresh">
          <i class="fa-solid fa-arrows-rotate"></i>
        </button>
      </f-alert>
    </section> 
   
    <div class="domain-dropdown">
      <app-alight-drop-down
      [group]="peekabooForm"
      [controlName]="'topic'"
      [required]="false"
      description="topicLabel"
      [disable]="false"
      label="Select Topic"
      [value]="'topicId'"
      [list]="domains"
      (change)="selectedTopic($event)"
    >
    </app-alight-drop-down>
    </div>

    <div class="domain-enquiry-links">
      <ng-container *ngFor="let menu of linksSectionData">
        <div [ngClass]="menu?.style">
          <h3>{{ menu?.heading }}</h3>
          <section *ngIf="!menu?.id" class="error-wrapper">
            <f-alert variant="error">
              <p class="full-width"> {{menu?.actionCode}} </p>
            </f-alert>
          </section>
          <ul>
              <li *ngFor="let subMenu of (menu?.subMenuList | sortBy: 'heading').slice(0, menu?.showMore ?  menu?.subMenuList.length : menu?.slicedSubMenuList) let i = index" >
              <button  (click)="rootScope.selectedLeftNavBarLink(subMenu,true)" >{{subMenu?.heading}}<i class="fa-light fa-arrow-up-right-from-square"></i></button>
            </li>
            <button *ngIf="menu?.subMenuList.length > menu?.slicedSubMenuList" mat-button color="primary" class="show-hide" (click)="menu.showMore = !menu.showMore">
              {{ menu?.showMore ? "Show Less" : "Show all" }}
              <span *ngIf="!menu?.showMore"><i class="fa-regular fa-angle-down"></i></span>
              <span *ngIf="menu?.showMore"><i class="fa-regular fa-angle-up"></i></span>
            </button>
          </ul>
        </div>
      </ng-container>
    </div>
  </div>
  <app-loader *ngIf="showPeekabooLoader" [loaderType]="loaderType" [loaderMsg]="showPeekabooLoaderMsg"></app-loader>
</div>
